import { render, staticRenderFns } from "./practices-filter.vue?vue&type=template&id=6d5f3881"
import script from "./practices-filter.vue?vue&type=script&lang=ts"
export * from "./practices-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports